import React from 'react';
import {
    FETCH_FEEDBACK_REQUEST,
    FETCH_FEEDBACK_REQUEST_SUCCESS,
    FETCH_FEEDBACK_REQUEST_FAILER,
    CREATE_FEEDBACK_REQUEST,
    CREATE_FEEDBACK_REQUEST_SUCCESS,
    CREATE_FEEDBACK_REQUEST_FAILER,
    FETCH_LISITNG_DROPDOWN_REQUEST,
    FETCH_LISITNG_DROPDOWN_SUCCESS,
    FETCH_LISITNG_DROPDOWN_FAILER,
} from './FeedbackActionTypes';

interface IInitialData {
    loading: boolean,
    feedbackData: any,
    error: string,

    dropdownLoader: boolean,
    dropDownlist: any,
    dropdownError: string,

    createLoader: boolean,
    createError: string

};

const initialState: IInitialData = {
    loading: false,
    feedbackData: [],
    error: "",

    dropdownLoader: false,
    dropDownlist: {},
    dropdownError: "",

    createLoader: false,
    createError: ""

};

const FeedbackReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_FEEDBACK_REQUEST:
            return {
                ...state,
                loading: true,
                error: ""
            }
        case FETCH_FEEDBACK_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                feedbackData: action.payload,
                error: ""
            }
        case FETCH_FEEDBACK_REQUEST_FAILER:
            return {
                ...state,
                loading: false,
                feedbackData: [],
                error: action.payload
            }

        case FETCH_LISITNG_DROPDOWN_REQUEST:
            return {
                ...state,
                dropdownLoader: true,
                dropDownlist: {},
                dropdownError: ""
            }
        case FETCH_LISITNG_DROPDOWN_SUCCESS:
            return {
                ...state,
                dropdownLoader: false,
                dropDownlist: action.payload,
                dropdownError: ""
            }
        case FETCH_LISITNG_DROPDOWN_FAILER:
            return {
                ...state,
                dropdownLoader: false,
                dropDownlist: {},
                dropdownError: action.payload
            }

        case CREATE_FEEDBACK_REQUEST:
            return {
                ...state,
                createLoader: true,
                createError: ""
            }
        case CREATE_FEEDBACK_REQUEST_SUCCESS:
            return {
                ...state,
                createLoader: false,
                createError: ""
            }
        case CREATE_FEEDBACK_REQUEST_FAILER:
            return {
                ...state,
                createLoader: false,
                createError: action.payload
            }

        default:
            return { ...state }
    }
};

export default FeedbackReducer;